module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?f51112347be6b44f9ef46151a971430d";